import React from "react";
import withStyles from "react-jss";
import loadable from "@loadable/component";
import { v4 } from "uuid";
import { BackgroundImage } from "ComponentsUI/BackgroundImage";
import { ProviderBannerInfo } from "ComponentsUI/ProviderBanner";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { webpSimpleTransformer } from "Helpers/ImageManager";
import AddressPopupHOC from "HOC/AddressPopupHOC";

const AddressSearchHomeContainerB = loadable(
	() => import("Containers/AddressSearchHomeContainerB")
);

const styles = (theme) => {
	return {
		root: {
			position: "relative",
			zIndex: 0,
			backgroundColor: "#162043",
			minHeight: "250px",
			paddingTop: "166px",
			"&:hover": {
				"& $carouselCtrl": {
					opacity: 1,
					visibility: "hidden",
				},
			},
		},
		carouselCtrl: {},
		wrapper: {
			padding: "55px 0 75px",
		},
		wrapperHeader: {
			width: "100%",
		},
		wrapperHeaderLeft: {
			marginBottom: "60px",
		},
		searchHeader: {
			fontSize: "24px",
			fontFamily: theme.fonts.bold,
			lineHeight: 1,
			letterSpacing: "-.67px",
			color: theme.palette.colors.white,
			marginBottom: "27px",
		},
		breadcrumbs: {
			marginBottom: "75px",
		},
		wrapperLogoAndName: {
			display: "flex",
			alignItems: "center",
			marginBottom: "22px",
		},
		logo: {
			marginRight: "21px",
			"& img": {
				objectFit: "scale-down",
				width: "100%",
				height: "56px",
				padding: "8px",
				borderRadius: "10px",
				boxSizing: "content-box",
				backgroundColor: "rgba(210, 206, 224, 0.6)",
			},
		},
		name: {
			fontFamily: theme.fonts.bold,
			fontSize: "24px",
			color: theme.palette.colors.white,
			margin: 0,
			lineHeight: "normal",
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			wrapper: {
				padding: "56px 0 75px",
			},
			breadcrumbs: {
				marginBottom: "60px",
			},
			wrapperHeaderLeft: {
				marginBottom: "55px",
			},
			searchHeader: {
				fontSize: "21px",
				marginBottom: "33px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				paddingTop: "195px",
			},
			wrapper: {
				padding: "55px 0 65px",
			},
			breadcrumbs: {
				marginBottom: "50px",
			},
			wrapperHeaderLeft: {
				marginBottom: "40px",
			},
			logo: {
				"& img": {
					height: "46px",
				},
			},
			searchHeader: {
				fontSize: "21px",
				marginBottom: "40px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				paddingTop: "60px",
			},
			wrapper: {
				padding: "20px 0 36px",
			},
			wrapperHeaderLeft: {
				width: "100%",
				marginBottom: "30px",
			},
			wrapperLogoAndName: {
				flexDirection: "column",
				marginBottom: "27px",
			},
			breadcrumbs: {
				marginBottom: "30px",
				minHeight: "79px",
			},
			logo: {
				display: "flex",
				justifyContent: "center",
				marginBottom: "16px",
				marginRight: 0,
				"& img": {
					minHeight: "46px",
				},
			},
			searchHeader: {
				fontSize: "21px",
				marginBottom: "18px",
				textAlign: "center",
			},
			name: {
				textAlign: "center",
			},
		},
	};
};

class PHeroBlock extends React.PureComponent {
	static defaultProps = {
		breadCrumbs: null,
	};

	render() {
		let classes = this.props.classes;
		let texts = this.props.text;

		let breadcrumbs = null;
		let brand_button = this.props?.data?.provider_settings?.brand_button
			? this.props.data.provider_settings.brand_button
			: null;
		if (this.props.breadCrumbs) {
			breadcrumbs = React.cloneElement(this.props.breadCrumbs, {
				background: !!this.props.background,
				white: true,
			});
		}

		let newViewSearch = this.props.showNewViewSearch;
		return (
			<div id={"provider_banner"} className={classes.root}>
				{this.props.background && (
					<BackgroundImage
						webpTransformer={webpSimpleTransformer}
						windowSizes={this.props.windowSizes}
						background={this.props.background}
						shiftY={25}
					/>
				)}
				<Container>
					<Row>
						<Col xs={12}>
							<div className={classes.wrapper}>
								<div className={classes.wrapperHeader}>
									<div
										className={classes.wrapperHeaderLeft}
										itemScope
										itemType="http://schema.org/ImageObject"
									>
										<div className={classes.breadcrumbs}>{breadcrumbs}</div>
										<div className={classes.wrapperLogoAndName}>
											<div className={classes.logo}>
												{!this.props.isStub && (
													<picture>
														<source
															type="image/webp"
															srcSet={webpSimpleTransformer(this.props.providerLogo)}
														/>
														<source srcSet={this.props.providerLogo} />
														<img
															src={this.props.providerLogo}
															itemProp="contentUrl"
															alt="Лого провайдера"
														/>
													</picture>
												)}
											</div>
											{!this.props.notH1 && (
												<h1 className={classes.name} itemProp="name">
													{this.props.h1}
												</h1>
											)}
											{this.props.notH1 && <div className={classes.name}>{this.props.h1}</div>}
										</div>
										{!!this.props.data.vip_provider && (
											<ProviderBannerInfo
												text={this.props.text}
												site={this.props.site}
												phone={this.props.phone}
												nameLegal={!this.props.isStub ? this.props.data.contacts.name_legal : ""}
												phoneSupport={this.props.phoneSupport}
												background={!!this.props.background}
												link={this.props.data.contacts.link}
												cardType={this.props.data.contacts.card}
												fakePhone={!this.props.isStub && this.props.data.vip_provider == 1}
												soldToProvider={this.props.data.sell_self?.provider}
												h1After={this.props.h1After}
												brand_button={brand_button}
												providerId={this.props.data.id}
											/>
										)}
									</div>
									<div className={classes.searchHeader}>
										{`${texts.CHECK_ADDRESS_PROVIDER_HEADER_1} ${this.props.data.name} ${texts.CHECK_ADDRESS_PROVIDER_HEADER_2}`}
									</div>
									<div>
										<AddressPopupHOC>
											<AddressSearchHomeContainerB
												withoutBorder={true}
												withoutContainer={true}
												withQuiz={true}
												sendGAWhenFulled={true}
												notJustifyCenter={true}
												providerId={this.props.data?.id}
												layoutB={this.props.windowSizes.xs && !newViewSearch}
												renderFormV2={
													(this.props.windowSizes.lg || this.props.windowSizes.md) && newViewSearch
												}
												layoutBV2={
													(this.props.windowSizes.sm || this.props.windowSizes.xs) && newViewSearch
												}
												apartment={newViewSearch}
												autoExpansion={!newViewSearch}
												houseInputId={v4()}
												streetInputId={v4()}
											/>
										</AddressPopupHOC>
									</div>
								</div>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}
export default withStyles(styles)(PHeroBlock);
